import React from "react";
import { EcpUserTable } from "../entities/ecp/ecp-user-entity";

export function EcpUsersPage(props) {
  return <EcpUserTable {...props} />;
}
